import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class ModalService {

  constructor(
    private readonly dialogService: DialogService,
  ) {}

  public open<T>(component: Type<T>, options?: DynamicDialogConfig<any>): DynamicDialogRef {
    return this.dialogService.open(component, { ...options });
  }

  public confirm<T>(component: Type<T>, options?: DynamicDialogConfig<any>): DynamicDialogRef {
    return this.dialogService.open(component, { ...options });
  }

  public close(ref: DynamicDialogRef): void {
    ref.close();
  }

}
